  
import axios from 'axios';
 
class RankingService {
  
  getRankingProgram(id) {
    return axios.get(`ranking/program?origin_id=${id}`); 
  }   
  getRankingCompany() {
    return axios.get(`ranking/company`); 
  }   
  getRankingVDP(id) {
    let config = {
      headers: {
        Authorization: ''
      }
    }
    return axios.get(`ranking/vdp/${id}`,config); 
  }   
  getRankingGeral(page, pageSize) {
    return axios.get(`ranking/general?page=${page}&pageSize=${pageSize}`); 
  }
  getRankingMensal(page, pageSize, month, year) {
    return axios.get(`report/filter-ranking?page=${page}&pageSize=${pageSize}&month=${month}&year=${year}`); 
  } 
}

export default new RankingService();